(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedDosageUnit', MedDosageUnit);

    MedDosageUnit.$inject = ['$resource'];

    function MedDosageUnit ($resource) {
        var resourceUrl =  'api/med-dosage-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
